import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuList, NavigationMenuItem, NavigationMenuLink } from "@/components/ui/navigation-menu";
function HeaderContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href]') as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute('href');
        if (!href) return;
        let hash = '';
        if (href.startsWith('#')) {
          hash = href;
        } else if (href.startsWith('/') && href.includes('#')) {
          const [path, hashPart] = href.split('#');
          if (path === '/' || path === window.location.pathname) {
            hash = '#' + hashPart;
          }
        }
        if (hash && hash !== '#') {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
            setIsMobileMenuOpen(false);
          }
        }
      }
    };
    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);
  return <header data-section-id="8592" className={`sticky top-0 z-50 w-full transition-all duration-500 border-b ${isScrolled ? "bg-black/80 backdrop-blur-md border-white/10 shadow-sm" : "bg-black border-transparent"}`}>
      <div className="container mx-auto px-4 h-20 flex items-center justify-between">
        {}
        <div className="flex-shrink-0">
          <Link to="/HomePage" className="block hover:opacity-90 transition-opacity">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608243/img/rankboost_logo_header.png" alt="Skin N' Bonez" className="h-7 w-auto object-contain" />
          </Link>
        </div>

        {}
        <div className="hidden md:flex items-center justify-center flex-1 px-8">
          {!loading && <NavigationMenu>
              <NavigationMenuList className="gap-8">
                {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
                    <NavigationMenuLink asChild>
                      <Link to={item.href || "#"} className="group relative px-1 py-2 text-[14px] font-sans uppercase tracking-wider text-white/80 hover:text-red-600 transition-colors duration-300">
                        {item.label}
                        <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 bg-red-600 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-300 ease-out" />
                      </Link>
                    </NavigationMenuLink>
                  </NavigationMenuItem>)}
              </NavigationMenuList>
            </NavigationMenu>}
        </div>

        {}
        <div className="flex items-center gap-4">
          <Button asChild variant="outline" className="hidden md:inline-flex rounded-[4px] border-white/40 text-white hover:bg-red-600 hover:text-white hover:border-red-600 transition-all duration-300 font-sans text-xs uppercase tracking-widest h-10 px-6 shadow-none">
            <Link to="#">
              Book Now
            </Link>
          </Button>

          {}
          <Button variant="ghost" size="icon" className="md:hidden text-white hover:text-red-600 hover:bg-transparent" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu">
            {isMobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
          </Button>
        </div>
      </div>

      {}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-black/95 backdrop-blur-xl border-b border-white/10 p-6 flex flex-col gap-6 shadow-2xl animate-in slide-in-from-top-5 duration-300">
          <nav className="flex flex-col gap-4">
            {!loading && menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} className="text-sm font-sans uppercase tracking-widest text-white/80 hover:text-red-600 transition-colors py-2 border-b border-white/10" onClick={() => setIsMobileMenuOpen(false)} data-index={i}>
                {item.label}
              </Link>)}
          </nav>
          <Button asChild className="w-full rounded-[4px] bg-red-600 text-white hover:bg-red-700 shadow-none font-sans uppercase tracking-widest">
            <Link to="#" onClick={() => setIsMobileMenuOpen(false)}>
              Book Now
            </Link>
          </Button>
        </div>}
    </header>;
}
export default function Navigation() {
  return <section id="site-navigation" className="dark bg-black text-white w-full">
      <MenuProvider menu_id="51" className="w-full">
        <HeaderContent />
      </MenuProvider>
    </section>;
}